let dictionaryPromise: Promise<Set<string>> | null = null;

function loadDictionary(): Promise<Set<string>> {
  dictionaryPromise ??= import("an-array-of-english-words").then(({ default: words }) => new Set(words));
  return dictionaryPromise;
}

function isDictionaryToken(token: string, dictionary: Set<string>): boolean {
  if (dictionary.has(token)) return true;

  // The source list contains bare words. Accept common compounds and
  // contractions only when every meaningful component is itself a word.
  if (token.includes("-")) {
    return token.split("-").every((part) => part.length > 0 && dictionary.has(part));
  }
  if (token.includes("'")) {
    const [stem, suffix, ...rest] = token.split("'");
    return rest.length === 0
      && dictionary.has(stem)
      && ["d", "ll", "m", "re", "s", "t", "ve"].includes(suffix);
  }
  return false;
}

export async function isDictionaryEntry(value: string): Promise<boolean> {
  const normalized = value.trim().toLowerCase().replace(/\s+/g, " ");
  if (!normalized) return false;
  const dictionary = await loadDictionary();
  return normalized.split(" ").every((token) => isDictionaryToken(token, dictionary));
}
